import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { useTranslation } from 'react-i18next';

// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import { event } from "jquery";
import $ from 'jquery';

const { config } = require('../api/api');


function HotelPayment({ initialTime = 15 * 60 }){
  
const [vendorKey, setVendorkey] = useState('');
const [token, setToken] = useState(false);
const[fname,setFname]=useState('');
const [timeExpired, setTimeExpired] = useState(false);
const[lname,setLname]=useState('');
const[parseData,setparseData]=useState('');
const[bookingpage,setbookingpage]=useState([]);
const [initiatePayment,setInitiatePayment] = useState(false)
    const [priceInfo,setPriceInfo]=useState(null);
     const [allInformation,setAllInformation]=useState(null);
       const [imgDetails,setImgDetails]=useState(null);
       const [roomDetails,setRoomDetails]=useState([]);
       const[hotelDetails,setHotelDetails]=useState(null);
       const [timeLeft, setTimeLeft] =useState(() => {
        const stored = sessionStorage.getItem('offerTimer');
        return stored ? Number(stored) : 15 * 60;
      });
    const [guestCount,setGuestCount]=useState("");
    const [nightsCount,setNightsCount]=useState("");
    const [roomGuestsData,setRoomGuestsData]=useState([]);
    const [roomClass,setRoomClass]=useState("");
    const [userData,setUserData]= useState("")

    
     // ✅ Load SmartBox script
     useEffect(() => {
       const script = document.createElement("script");
       script.src = config.amwalpayURL;
       script.async = true;
       document.body.appendChild(script);
   
       return () => {
         document.body.removeChild(script);
       };
     }, []);

     useEffect(() => {
        if (timeLeft <= 0){
          setTimeExpired(true);
          return;
        }
         
        const timer = setInterval(() => {
          setTimeLeft((prevTime) =>{
            const updated =prevTime - 1;
            sessionStorage.setItem('offerTimer', updated);
        return updated;
      });
        }, 1000);
        return () => clearInterval(timer);
      }, [timeLeft]);
    
      const handleRestart = () => {
        sessionStorage.setItem("offerTimer", 15 * 60);
        window.location.href="/hotel-search" 
      };
    
    
    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
      };
    

    
    const base_url = config.baseURL;
    const redirect_url = config.redirectURL;
    const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
    const [loading, setLoading] = useState(true);

    const { t } = useTranslation();



    useEffect(() => {
    
        const postvData = { organization_name: "Superjet" };
        
    
        if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {
    
          
          fetch(base_url + '/create_organization', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postvData),
          })
            .then(response => response.json())
            .then(data => {
              setVendorkey(data.result[0].vendor_key);
            })
            .catch(error => {
              console.error('Error posting data:', error);
            });
    
    
        }
      }, [vendorKey]);


       useEffect(()=>{
          const storedData = Cookies.get('auth_key');
          if (storedData !== undefined) {
            const storedtoken = JSON.parse(storedData);
            setToken(storedtoken);
          }
          else {
            // alert("token expired");
            // window.location.href='/';
          }
        })
       useEffect(()=>{
    
              const getpricing=async()=>{
                
              const offer_id=sessionStorage.getItem("Offer_id");
              const hotel_offer_data={
                  etmtoken:token,
                  offer_id:offer_id
                  }
               try {
                  const response =await fetch(`${base_url}/hotel_pricing`, {
                     method: "POST",
                     headers: {
                       "Authorization": "Bearer "+ vendorKey,
                       "Content-Type": "application/json"
                     },
                     body: JSON.stringify(hotel_offer_data)
                   });
                   if (!response.ok) {
                     console.log("http response status : ", response.status)
                   window.location.href="/hotel-rooms";

                   }
                   else {
                     const data = await  response.json();
                     if(data.message==="success"){
                      
                     setPriceInfo(data.result.price_per_currency);
                     
                     setImgDetails(data.result.image);
                     const {rooms,...filter}=data.result;
                     setAllInformation(filter);
                     setRoomDetails(rooms);
                     setHotelDetails(data.result.hotel);
                      //Guest Count
                var guest_count=0;
                for(let i=0;i<rooms.length;i++){
                  const adult_qty= rooms[i].adult_qty;
                  const child_qty=rooms[i].children.length;
                  guest_count+=adult_qty+child_qty;
                }
                setGuestCount(guest_count);

               // nights Count
               const checkin_date=data.result.stay_dates?.from;
             
               const checkout_date=data.result.stay_dates?.to;

               const diff_ms=Math.abs(new Date(checkout_date)-new Date(checkin_date));
               const days_diff=Math.ceil(diff_ms/( 1000 * 60 * 60 * 24))
                setNightsCount(days_diff);

                const hotel= sessionStorage.getItem("hotelpayment");
                if (hotel!==null && hotel!==undefined && hotel!=="") {
                  const parseData=hotel?JSON.parse(hotel):null;
                 
                    // setFname(parseData?.order_payload.rooms?JSON.parse(parseData?.order_payload.rooms)[0]?.guests[0]?.firstname:""); 
                    //  setLname(parseData?.order_payload.rooms?JSON.parse(parseData?.order_payload.rooms)[0]?.guests[0]?.lastname:"")
                    if(parseData){
                    const guest_info=JSON.parse(parseData?.order_payload?.rooms);
                   for(let i=0;i<guest_info.length;i++){
                    guest_info[i].room_class=data.result.rooms[0].class;
                   }

                     setRoomGuestsData(guest_info);
                    }
                          }


                     }
                   }
                 }
                 catch (err) {
                   console.log("Hotel Show Offer API Err : ", err);
                   window.location.href="/hotel-details";
                   setLoading(false);
                      }
                      setLoading(false);
                    }
                  if(vendorKey && token){
                    getpricing()
                  }
                    },[vendorKey,token]) 

useEffect(()=>{
 const get_room_info=sessionStorage.getItem("roomInfo");
 if(get_room_info){
    setRoomClass(get_room_info);
 }

},[])

useEffect(() => {
          const storedUserString = Cookies.get('userData');
          if (storedUserString !== undefined) {
            const user_data = JSON.parse(storedUserString);
          
            setUserData(user_data);
            
            
          } else {
          //   alert('Login Session Expired');
          //   window.location.href = '/';
          }
      
        }, []);



    
    const createOrder= async (e)=>{
     
       
      e.preventDefault();
      try {
        const getOrderData=sessionStorage.getItem("hotelpayment");
      
         const req_data=getOrderData!==undefined&&getOrderData!==""&&getOrderData!==null?JSON.parse(getOrderData):null;
         if(req_data){
      
          const response =await fetch(base_url + "/create_hotel_order", {
            method: "POST",
            headers: {
              "Authorization": "Bearer "+ vendorKey,
              "Content-Type": "application/json"
            },
            body: JSON.stringify(req_data)
          });
          if (!response.ok) {
            console.log("http response status : ", response.status)
          }
          else {
            const data = await  response.json();
            if(data.message==="success"){
            // setHotellist(data.result.data.hotels);
            }
          }
        }
        }
        catch (err) {
          console.log("Hotel Show Offer API Err : ", err);
             }
    }
    const generateRandomString = (length) => {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters.charAt(randomIndex);
      }
      return result;
    };
    const handleSubmit = async (e) => {
        debugger
        e.preventDefault();


        
        // console.log(searchResult);
        // console.log(searchData);
        setLoading(true);
        // const amount = fulldetailsvalue.total;
        // const currency = fulldetailsvalue.currency;
        const getOrderData=sessionStorage.getItem("hotelpayment");
      
        var req_data=getOrderData!==undefined&&getOrderData!==""&&getOrderData!==null?JSON.parse(getOrderData):null;
        if(req_data){
        
          const {etmtoken,order_payload}=req_data;
          const get_card_id=sessionStorage.getItem("hotelCardId");
           
      const key= "uA$te4F91PksQ2@E#yGmH8zL&Xd57T";
      const final_key=get_card_id.replace(key,"");
          
        var hotel_data = {
            "hotel_id":order_payload.h_offer_id,
            "hotel_card_id":atob(final_key),
            "amount_cents":priceInfo?.USD?.total,
            "currency":priceInfo?.USD?.currency,
            // "reference_id": ran,
            "redirection_url": redirect_url+"/hotel_order_payment_log",
            // "redirection_url": "https://google.com/hotel_order_payment_log",
            "description": "hotel",
            "first_name":order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.firstname:"",
            "last_name": order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.lastname:"",
            "phone_no": order_payload.phones[0],
            "email": order_payload.emails[0],
            "req_data":getOrderData
        }

        
        // const rand = Math.floor(Math.random() * 90000000) + 10000000;
        // const rnd = rand.toString();
        const  usrtok=userData?.access_token;
       const data = {
            "hotel_id":order_payload.h_offer_id,
            "hotel_card_id":Number(atob(final_key)),
            "amount_cents": priceInfo?.USD?.total,
            "is_live": "true",
            "first_name": order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.firstname:"",
            "last_name":order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.lastname:"",
            "phone_no": order_payload.phones[0],
            "email":order_payload.emails[0],
            "save_selection": "true",
            "redirection_url": base_url+"/hotel_payment_log_info",
            "currency": priceInfo?.USD?.currency,
            "description": "Payment hotel **",
            "token":usrtok,
            "req_data":getOrderData

          };
       
    // debugger
    if (vendorKey !== ''&&usrtok!=='') {
    
      fetch(base_url+'/ehotel_payments', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${vendorKey}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then(response => response.json())
        .then(data => {
          setLoading(false);
          if (data.message === "success") {
            setInitiatePayment(true);
        var parsedata = JSON.parse(data.result.payment_details)
        const { secureHash, trxParams } = parsedata;
        window.SmartBox.Checkout.configure = {
          MID: trxParams.MerchantId,
          TID: trxParams.TerminalId,
          CurrencyId: trxParams.CurrencyId,
          AmountTrxn: trxParams.Amount,
          MerchantReference: trxParams.MerchantReference,
          LanguageId: "en",
          PaymentViewType: 1,
          TrxDateTime: trxParams.TrxDateTime,
          SessionToken: trxParams.SessionToken,
          SecureHash: secureHash,
          completeCallback: async (resp) => {
            
            console.log("✅ Payment success:", resp.data);
            setLoading(true);
            // Verify payment
            const verifyRes = await fetch(base_url + "/ehotel_payment_update", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(resp.data),
            });
            const verifyJson = await verifyRes.json();
            if (verifyJson.valid === true) {
              window.location.href = verifyJson.data;
            }
          },
          errorCallback: (err) => {
            setLoading(false);
            //  window.location.href = `${config.redirectURL}/sanad-visapayment-cancel`;
            //  window.location.href = `${config.redirectURL}/sanad-visa-order-status?ref_no=${OrderDetails.sanad_reference_no}`;
            console.error("❌ Payment error:", err)
        },
          cancelCallback: () => {
            setInitiatePayment(false)
            console.warn("⚠️ Payment cancelled")
        }
        };

        window.SmartBox.Checkout.showSmartBox();
      }
          // debugger
          // if(data.message==="success"){
          //   window.location.href = data.result?.client_url;
          // }
    
          // setpKey(data.result.payment_token);
    
    
        })
        .catch(error => {

          setInitiatePayment(false);
          console.error('Error posting data:', error);
        });
    
    }  
      };

    }
    // const handleSubmit = async (e) => {
      
    //   e.preventDefault()
    //     setLoading(true)
    //     var ran = generateRandomString(10);
        
    //     // const amount = fulldetailsvalue.total;
    //     // const currency = fulldetailsvalue.currency;
    //     const getOrderData=sessionStorage.getItem("hotelpayment");
      
    //     var req_data=getOrderData!==undefined&&getOrderData!==""&&getOrderData!==null?JSON.parse(getOrderData):null;
    //     if(req_data){
        
    //       const {etmtoken,order_payload}=req_data;
    //       const get_card_id=sessionStorage.getItem("hotelCardId");
    //     var hotel_data = {
    //         "hotel_id":order_payload.h_offer_id,
    //         "hotel_card_id":get_card_id,
    //         "amount_cents":priceInfo?.USD?.total,
    //         "currency":priceInfo?.USD?.currency,
    //         "reference_id": ran,
    //         "redirection_url": base_url+"/hotel_order_payment_log",
    //         // "redirection_url": "https://google.com/hotel_order_payment_log",
    //         "description": "hotel",
    //         "first_name":order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.firstname:"",
    //         "last_name": order_payload.rooms?JSON.parse(order_payload.rooms)[0]?.guests[0]?.lastname:"",
    //         "phone_no": order_payload.phones[0],
    //         "email": order_payload.emails[0],
    //         "req_data":getOrderData
    //     }

        

    //     if (vendorKey) {
    //         fetch(base_url + '/create_hotel_payment', {
    //             method: 'POST',
    //             headers: {
    //                 'Authorization': `Bearer ${vendorKey}`,
    //                 'Content-Type': 'application/json',
    //             },
    //             body: JSON.stringify(hotel_data),
    //         })
    //             .then(response => response.json())
    //             .then(data => {
    //                 const results = data?.result;
                    
    //                 // alert(data?.message)
    //                 if(data?.message==="success"){
    //                     window.location.href = results?.client_url
    //                     setLoading(false);

    //                 }else{
    //                     setLoading(false);
    //                 }
    //             })
    //             .catch(error => {
    //                 console.error('Error posting data:', error);
    //                 setLoading(false); 
    //             });
    //     } else {
    //         console.error('Error: vendorKey is missing or invalid');
    //     }
    //   }
    // };
    const StarRating = ( rating, totalStars = 5 ) => {
     
      const filledStars = Math.round(rating);
      const emptyStars = totalStars - filledStars;
      const filledArr=new Array(filledStars);
      filledArr.fill("fullStar");
      const emptyArr=new Array(emptyStars);
      emptyArr.fill("fullStar");
      return (
          <div className="star-rating" style={{ display: 'flex', padding: '0' }}>
              {filledArr.map((_, index) => (
                  <span
                      key={`filled-${index}`}
                      //   onClick={() => handleStarClick(index)}
                      style={{ color: 'gold', cursor: 'pointer' }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
                          <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                      </svg>
                  </span>
              ))}
              {emptyArr.map((_, index) => (
                  <span
                      key={`empty-${index}`}
                      //   onClick={() => handleStarClick(filledStars + index)}
                      style={{ color: 'gray', cursor: 'pointer' }}
                  >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star" viewBox="0 0 16 16">
                          <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
                      </svg>
                  </span>
              ))}
          </div>
      );

  }  

  const handleBackBtn=(e)=>{
    e.preventDefault();
    window.location.href="/hotel-booking"
  }

   return (
    <Fragment>
        
        <div className="header_section1">

<Navbar />


<div className="container-fluid bg-breadcrumb">
    <div className="container text-center py-5">
        <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'e-Hotel Booking Details' : 'تفاصيل حجز الفندق الإلكتروني\n'}</h3>
    </div>
</div>


</div>
            <div className="features_section">
  {/* {bookingpage.map((item,index)=>( */}
                <div className="container">

                <div className="row p-4">
            <div className="col-md-1">
            </div>
            <div className="col-md-6">
            <div className="card p-2 shadow"
              style={{
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >{t("Guests")}</h2>
            </div>
            <div className="card p-2 shadow mt-0">
                <table className="table table-bordered ">
                    <thead style={{backgroundColor:"#f4f6fb"}}>
                <tr>
                    <td>{t("Room")}</td>
                    <td>{t("Guests")}</td>
                </tr>
                    </thead>
                    <tbody>
                       
                            
                        
                        
                           
                            {roomGuestsData.map((room)=>(
                              <tr>
                   <td>{roomClass}</td>
                    <td>
                  {room.guests.map((guest)=>(
                  
                    <div className="d-flex">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                    <p className="mx-1">{guest.firstname}&nbsp;{guest.lastname} </p>
                    </div>
                  ))} 
                   </td>
                            </tr>
                            ))}
                                
                           
                      
                    </tbody>
                </table>
            </div>
            <div className="card p-2 shadow mt-3"
              style={{
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
                <div className="d-flex justify-content-end">
              <h3 className="card-title p-1">{t("Order")} {t("cost")} : {priceInfo?.USD?.total?priceInfo?.USD?.total+".00 USD":""}</h3>
              </div>
            </div>
            <div className="card p-3 shadow">
            <div className="d-flex justify-content-between">
                <button className="btn-primary text-white my-3 py-1" style={{ height: '35px', width: '100px' }}  onClick={handleBackBtn}>
                  {t("Back")}
                </button>
                <button className="btn-primary text-white my-3 py-1"   
                 onClick={(e)=>{handleSubmit(e)}}
                  style={{ height: '35px', width: '100px' }}>
                  {t("Buy")}
                </button>
              </div>
              </div>
            </div>
            <div className="col-md-4">
            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <h2 className="card-title p-0" >{t("Booking")} {t("details")}</h2>
              </div>

            <div className="card p-3 shadow">
              <div className="d-flex flex-column" >
                <h3 class="fw-bold p-0">{hotelDetails?.name}</h3>
                
                {hotelDetails!==null?
                <>
                 {StarRating(hotelDetails?.stars,5)}
                 </>:""}
              </div>
              <p>{hotelDetails?.address}</p>
              <div style={{
                height: "150px",
                width: "100%",
                overflow: "hidden",
                 }}>
                <img src={imgDetails?.url} class="w-100 h-20 object-fit-cover" alt=""></img>
              </div>
              <table class="table table-borderless">
                <tbody>
                  <tr>
                    <th >{t("Check-in")}</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.from:""}</td>
                  </tr>
                  <tr>
                    <th >{t("Check-out")}</th>
                    <td>{allInformation!==null?allInformation?.stay_dates?.to:""}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Nights")}</th>
                    <td>{nightsCount}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Guests")}</th>
                    <td>{guestCount}</td>
                  </tr>
                  <tr>
                    <th scope="row">{t("Rooms")}</th>
                    <td>{roomDetails?.length>0?roomDetails.length:"0"}</td>
                  </tr>
                </tbody>
              </table>
              <div>
                <h3>{t("Order")} {t("cost")} : {priceInfo?.USD?.total?priceInfo?.USD?.total+".00 dollars":""}</h3>
              </div>
              </div>

            <div className="card p-3 shadow"
              style={{
                //   width: '250px',
                //   height: '160px',
                boxShadow: '5px 5px 15px rgba(0, 0, 0, 0.3)',
                Width: "100%"
              }}>
              <div className="d-flex">
                <h2 className="card-title p-0">{t("Cancellation")} {t("Policy")}</h2>
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="skyblue" class="bi bi-exclamation-circle-fill ml-2 mt-1" viewBox="0 0 16 16">
                  <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                </svg>

              </div>
              <div className="border border-info rounded px-2 py-3 bg-light">
                <h3>{t("Attention")}!</h3>
                <p style={{margin:"0px"}}>{allInformation!==null?allInformation?.cancel_policy?.description.split("\n").map((m,can_i)=>(
                
                    <>
                    {(can_i%2)===1?<br/>:<></>}
                    {m}
                 </>
                )):""}</p>
              </div>
              <span style={{fontSize:"12px"}}><span style={{ color: "red" }}>*</span>{lnstr=="en"? "Time Zone according to your settings is (UTC +0)":"الوقت محلي للموقع بنطاق (UTC +0)"}</span>
            </div>
            <div className="mt-4">
              <h3 style={{ fontSize: "20px" }}>{formatTime(timeLeft)}</h3>
              <span>{t("Pay")} {t("for")} {t("your")} {t("order")} {t("within")} {("15")} {t("minutes")}</span>

              
            </div>
          </div>

            <div className="col-md-1">
                </div>

        </div>
                </div>
   {/* ))}  */}
   </div>
   <Footer />
   
    {timeExpired && !initiatePayment && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "10px",
              width:"350px",
              maxWidth: "400px",
              textAlign: "center",
              boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            }}
          >
            <h4>⏰ {t("Current")} {t("session")} {t("is")} {t("over")}.</h4>
            <p>{t("Please")} {t("update")} {t("your")} {t("search")} {t("request")}</p>
            <button onClick={handleRestart} className="btn mt-3">
              {t("Repeat")} {t("the")} {t("search")}
            </button>
          </div>
        </div>
      )}
   {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
   )
}
export default HotelPayment;

